import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { userUrl } from '@/constants/urls';
import {
  columnNameLink,
  columnTools,
  columnApproved,
  columnEmail,
  columnRole,
  columnRoleLink,
  columnRoleLinkNoFilter,
  columnSearchable,
  columnCreatedOn,
  columnUpdatedOn,
  columnUserGroups,
  columnArchived,
  columnName, hasColumn,
} from '@/constants/fields';
import MessageCell from '@/components/table/MessageCell';
import DateCell from '@/components/table/DateCell';
import LinkCell from '@/components/table/LinkCell';
import SelectableRow from '@/components/table/SelectableRow';
import UserTools from '../containers/UserTools';
import UserApprovalCell from '../containers/UserApprovalCell';
import UserSearchableCell from '../containers/UserSearchableCell';
import UserRoleCell from './UserRoleCell';
import UserArchiveCell from '../containers/UserArchiveCell';
import UserNameCell from './UserNameCell';

const UserRow = ({
  category,
  user,
  onCheckBoxClick,
  updateFilterRole,
  upward,
  roleName,
  className,
  columns = [
    columnNameLink,
    columnSearchable,
    columnApproved,
    columnArchived,
    columnEmail,
    columnRole,
    columnTools,
    columnCreatedOn,
    columnUpdatedOn,
    columnUserGroups,
  ],
}) => (
  <SelectableRow
    className={clsx('aridhia-user-row', className)}
    columns={columns}
    error={user.archived}
    label={user.name}
    selected={user.selected}
    onClick={() => onCheckBoxClick(user.code)}
    warning={!user.archived && !user.approved}
  >
    {hasColumn(columns, [columnName, columnNameLink]) && (
      <UserNameCell user={user} asLink={hasColumn(columns, columnNameLink)} />
    )}
    {hasColumn(columns, columnEmail) && (<LinkCell title={user.name} value={user.email} />)}
    {hasColumn(columns, [columnRoleLink, columnRoleLinkNoFilter, columnRole]) && (
    <UserRoleCell
      asLink={hasColumn(columns, [columnRoleLink, columnRoleLinkNoFilter])}
      role={user.role}
      category={category}
      roleName={roleName}
      updateFilterRole={updateFilterRole}
      roleFilter={hasColumn(columns, columnRoleLink)}
    />
    )}
    {hasColumn(columns, columnUserGroups) && (
      <MessageCell messageId="users.groups.assigned" messageArgs={{ value: user.metrics.assigned_usergroups }} />
    )}
    {hasColumn(columns, columnCreatedOn) && (<DateCell content={user.created_at} />)}
    {hasColumn(columns, columnUpdatedOn) && (<DateCell content={user.updated_at} />)}
    {hasColumn(columns, columnArchived) && (<UserArchiveCell user={user} category={category} />)}
    {hasColumn(columns, columnApproved) && (<UserApprovalCell user={user} category={category} />)}
    {hasColumn(columns, columnSearchable) && (<UserSearchableCell user={user} category={category} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <UserTools
          url={userUrl(user, '#')}
          upward={upward}
          category={category}
          user={user}
        />
      </Table.Cell>
    )}
  </SelectableRow>
);

export default UserRow;
